// import {PayloadAction} from '@reduxjs/toolkit';
import {assign} from 'lodash-es';

export const setCommonData = (state, action) => {
    assign(state, action.payload);
};